import { MutationType, STPageType } from '@tencent/slide-sdk-pb-model';
import { BaseMutation } from '../base/base-mutation';
import { Rule } from '../base/mutation-rules';
import type { MaybeError } from '../base/base-mutation';
import type { IValidMovePageMutationData } from '../base/valid-mutation-data';
import type { PresentationDataModel } from '../../model/presentation-data-model';

export class MovePageMutation extends BaseMutation<PresentationDataModel, IValidMovePageMutationData> {
    public readonly type: MutationType = MutationType.MovePage;

    public apply(presentation: PresentationDataModel) {
        const { pageType, srcParentPageId, destParentPageId, srcIndex, destIndex } = this.data;
        if (pageType === STPageType.slide) {
            presentation.store.moveSlide(srcIndex, destIndex);
            return;
        }
        if (pageType === STPageType.slideLayout) {
            presentation.store.moveLayout(srcParentPageId, destParentPageId, srcIndex, destIndex);
            return;
        }
        if (pageType === STPageType.slideMaster) {
            presentation.store.moveMaster(srcIndex, destIndex);
        }
    }

    public invert(): [IValidMovePageMutationData] {
        const { pageId, pageType, srcParentPageId, destParentPageId, srcIndex, destIndex } = this.data;
        return [
            {
                type: MutationType.MovePage,
                pageId,
                pageType,
                srcParentPageId: destParentPageId,
                destParentPageId: srcParentPageId,
                srcIndex: destIndex,
                destIndex: srcIndex,
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, pageType, srcParentPageId, destParentPageId, srcIndex, destIndex } = this.data;

        if (pageType === STPageType.slide) {
            return Rule.every(
                Rule.pageList.should.containSlideInPosition(presentation, srcIndex, pageId),
                Rule.page.can.insertIntoSlideList(presentation, pageId, destIndex),
            );
        }

        if (pageType === STPageType.slideLayout) {
            return Rule.every(
                Rule.pageList.should.containLayoutInPosition(presentation, srcParentPageId, srcIndex, pageId),
                Rule.page.can.insertIntoLayoutIdList(presentation, pageId, destParentPageId, destIndex),
            );
        }

        if (pageType === STPageType.slideMaster) {
            return Rule.every(
                Rule.pageList.should.containMasterInPosition(presentation, srcIndex, pageId),
                Rule.page.can.insertIntoMasterList(presentation, pageId, destIndex),
            );
        }
    }
}
